import { Dispatch, Middleware, MiddlewareAPI, Action } from 'redux'
import { MESSAGE_TYPES } from 'types/globalMessaging'
import { showMessage, hideMessage } from 'utils/actions/globalMessaging'
import {
  APPROVE_LANE_ACTION_TYPES,
  SAVE_LANES_ACTION_TYPES,
  fetchCarrierLanes,
  openLaneCreatedModal,
} from 'apps/carrier/utils/actions/carrierLanes'
import { getCapacity } from '../actions/capacity'
import { IStore } from '../reducers'

const {
  APPROVE_LANE_FAILURE,
  APPROVE_LANE_REQUEST,
  APPROVE_LANE_SUCCESS,
} = APPROVE_LANE_ACTION_TYPES

const { SAVE_LANES_REQUEST, SAVE_LANES_SUCCESS } = SAVE_LANES_ACTION_TYPES

interface IAction extends Action<string> {
  error?: string
}

export const carrierLanes: Middleware = (store: MiddlewareAPI<Dispatch, IStore>) => (
  next: Dispatch
) => (action: IAction) => {
  const hideCurrentMessage = [APPROVE_LANE_REQUEST, SAVE_LANES_REQUEST].includes(action.type)
  if (hideCurrentMessage) {
    const currentMessage = store.getState().globalMessaging.message
    if (currentMessage) {
      store.dispatch(hideMessage(currentMessage.id))
    }
  }

  const errorOccurred = [APPROVE_LANE_FAILURE].includes(action.type)
  if (errorOccurred && action.error) {
    store.dispatch(showMessage(action.error, { type: MESSAGE_TYPES.alert }))
  }

  if (action.type === APPROVE_LANE_SUCCESS) {
    store.dispatch(showMessage('Lane converted to Contracted Rate.', { type: MESSAGE_TYPES.info }))
  }

  if (action.type === SAVE_LANES_SUCCESS) {
    const {
      carrier: { carrierDetails },
      carrierLanes: { targetLane },
    } = store.getState()
    const carrierId = carrierDetails!.id
    store.dispatch(fetchCarrierLanes(carrierId))
    store.dispatch(getCapacity(carrierId))
    if (!targetLane) {
      store.dispatch(openLaneCreatedModal())
    } else {
      store.dispatch(showMessage('Lane sucessfully updated.', { type: MESSAGE_TYPES.info }))
    }
  }

  return next(action)
}
